const fromdata = [
	{
	  inputdata: '',
	  title: '角色名称',
	  fontSize: '14px',
	  color: '#333333',
	  placeholder: '请输入',
	  types: 'text',
	  inputtype: 'input',
	  width: '480px'
	},
	{
	  inputdata: '',
	  title: '描述',
	  fontSize: '14px',
	  color: '#333333',
	  placeholder: '请输入',
	  types: 'text',
	  inputtype: 'input',
	  width: '480px'
	}
  ]
export default fromdata; 

